<template>
  <div>
    <v-container v-if="pageLoading" grid-list-xl text-xs-center>
        <v-layout>
            <v-flex>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    <v-alert
      :value="true"
      type="info"
      v-if="!availableDocuments && !pageLoading"
    >
        En este momento no hay firma de documentos activa
    </v-alert>
    <div v-else-if="!pageLoading">
      <v-toolbar flat color="white">
        <v-toolbar-title>Firmar documentos - {{ pageTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid class="pa-0 pt-2">
        <v-layout row wrap class="table-responsive" >
          <table class="table table-striped table-hover table-bordered elevation-3" >
            <thead>
              <tr>
                <th>DOCUMENTO</th>
                <th><i class="material-icons">family_restroom</i><br>{{ user.name }}<br><small style="font-weight: 400">FAMILIA</small></th>
                <th v-for="student in students" :key="student.student_id">
                  <i class="material-icons">child_care</i><br> {{ student.first_name }}<br><small style="font-weight: 400">{{ schools[`${student.school_id}`] }}</small>
                </th>
              </tr>
            </thead>
            <tbody>
                <tr
                  v-for="(document, i) in documents"
                  :key="`ds-${i}`"
                >
                <th>
                  <div style="min-width: 300px">{{ document.document }}<br><small style="font-weight: 400">{{ document.sign_desc }}</small></div>
                </th>
                <td style="text-align: center; width: 160px;">
                  <div v-if="document.family && document.document_type == 'FML'">
                    <v-btn      
                      v-for="doc in document.family" :key="doc.id"
                      flat
                      block
                      @click="handleSign(document, doc)"
                    >
                      <v-icon :color="getColor(doc['360_document_status'])">{{ doc['360_document_status'] == 'F' ? 'search' : document.several_signs == 1 ? 'pending_actions' : 'pending_actions' }}</v-icon>
                      
                      {{ doc['360_document_status'] == 'F' ? 'Firmado' : document.several_signs == 1 ? 'Firmar' : 'Por Firmar' }}
                      <!-- <small v-if="doc['360_document_status'] == 'F'" class="mx-2">({{ doc.updated_at }})</small> -->
                    </v-btn>
                    <div v-if="document.several_signs == 1">
                      <v-btn  
                        @click="handleSign(document, document.family[0], true)"
                        flat
                        block
                      >
                        <v-icon :color="getColor('N')">note_add</v-icon> Firmar nuevo
                      </v-btn>
                    </div>
                  </div>
                  <div v-else class="text-center">
                    <i class="material-icons grey--text text--lighten-1">highlight_off</i>
                  </div>
                </td>
                <td v-for="student in students" :key="student.student_id+document.document_id" style="text-align: center; width: 160px;">
                    <div v-if="Object.keys(document[`stu_${student.student_id}`]).length > 0 && document.document_type == 'STU'">
                      <!-- {{document}} -->
                      <v-tooltip v-for="doc in document[`stu_${student.student_id}`]" :key="doc.id" top>
                        <v-btn 
                          flat
                          block
                          slot="activator"
                          @click="handleSign(document, doc)"
                        >
                          <v-icon :color="getColor(doc['360_document_status'])">{{ doc['360_document_status'] == 'F' ? 'search' : document.several_signs == 1 ? 'pending_actions' : 'pending_actions' }}</v-icon>
                          
                          {{ doc['360_document_status'] == 'F' ? 'Firmado' : 'Por Firmar' }}
                          </v-btn>
                        <span>Estado: {{ getStatusText(doc['360_document_status']) }}<br>Fecha: {{ doc.hasOwnProperty('updated_at') ? doc.updated_at : '' }}</span>
                      </v-tooltip>
                      <div v-if="Object.keys(document[`stu_${student.student_id}`]).length > 0 && document.several_signs == 1">
                        <v-btn  
                          
                          @click="handleSign(document, document[`stu_${student.student_id}`][0], true)"
                          flat
                          block
                        >
                          <v-icon :color="getColor('N')">note_add</v-icon> Firmar nuevo
                        </v-btn>
                      </div>
                    </div>
                    <div v-else class="text-center">
                      <i class="material-icons grey--text text--lighten-1">highlight_off</i>
                    </div>
                  </td>
                </tr>
            </tbody>
          </table>
        </v-layout>
      </v-container>
    </div>
    <v-dialog
      v-model="dialogDigitalSign"
      fullscreen>
      <!-- studentId = {{ parseInt(rowid_tercero) }}<br>
      documentId = {{ parseInt(documentSignId) }}<br>
      action = {{ vista_action }}<br>
      processId = {{ parseInt(document_process_id) }}<br>
      recordId = {{ vista_record_id }} -->
      <digital-sign-comp
        v-on:closeDialog="closeSignDialog"
        :studentId="parseInt(rowid_tercero)"
        :documentId="parseInt(documentSignId)"
        :action="vista_action"
        :processId="parseInt(document_process_id)"
        :recordId="vista_record_id"
      ></digital-sign-comp>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import DigitalSignComponent from './digital_sign'
  export default {
    name: 'documents-employee-view',
    components: {
      'digital-sign-comp': DigitalSignComponent,
    },
    data() {
      return {
        documents: [],
        students: [],
        pageLoading: true,
        dialogDigitalSign: false,
        documentSignId: 0,
        document_process_id: 0,
        vista_action: '',
        vista_record_id: '',
        rowid_tercero: '',
        schools: [],
      }
    },
    computed: {
      pageTitle() {
        let title = ''
        if (this.documents.length > 0) {
          title = this.documents[0].sign_desc
        }
        return title
      },
      availableDocuments() {
        return this.documents.length > 0
      },
      ...mapGetters({
        user: 'authUser'
      })
    },
    created () {
      this.init();
      this.schools[10000] = 'Early years'
      this.schools[11000] = 'Elementary School'
      this.schools[12000] = 'Middle School'
      this.schools[13000] = 'High School'
      this.schools[14000] = 'Admissions'
    },
    methods: {
      init() {
        axios.get('/api/student/available/documents')
          .then(resp => {
            if (resp.status === 200) {
              this.documents = resp.data.documents
              this.students = resp.data.students
              this.pageLoading = false
            }
          })
          .then(err => {
            this.pageLoading = false
          })
      },
      getColor(number) {
        let color = ''
        switch (number) {
          case 0: color = 'primary'; break;
          case 'P': color = 'accent'; break;
          case 'F': color = 'success'; break;
          case 'N': color = 'pink'; break;
          default: color = 'primary'; break;
        }
        return color
      },
      getStatusText(status) {
        let text = ''
        switch (status) {
          case null: text = 'Sin firmar'; break;
          case 'P': text = 'Pendiente'; break;
          case 'F': text = 'Firmado'; break;
          case 'N': text = 'Nuevo'; break;
          default: text = ''; break;
        }
        return text
      },
      async handleSign(document, target, isNew = false) {
        let newIdProcess = 0
        // console.log(document, target)
        if (isNew) {
          const payload = {
            sign_date_id: document.sign_date_id,
            student_id: target.student_id,
            document_id: document.document_id,
          }
          const { data } = await axios.post('/api/documents/serveral_signs/add_new', payload)
          newIdProcess = data.id
        }

        if (!isNew){
          if (target[`360_document_status`] == 'F') {
            this.vista_action = 'SHOW'
            this.vista_record_id = target['360_document_id'] != '' ? target['360_document_id'] : null
            this.dialogDigitalSign = true
            return
          }
          if (target[`360_document_status`] == 'P') {
            this.vista_action = 'UPDATE'
            this.document_process_id = target.id
            this.documentSignId = document.vista_id
            this.vista_record_id = target['360_document_id'] != '' ? target['360_document_id'] : null
            this.dialogDigitalSign = true
            this.rowid_tercero = target.rowid_tercero
            return
          }
        }
        // console.log(isNew, newIdProcess, document.id)
        this.vista_action = 'CREATE'
        this.document_process_id = isNew ? newIdProcess : target.id
        this.documentSignId = document.vista_id
        this.rowid_tercero = target.rowid_tercero
        this.dialogDigitalSign = true
      },
      closeSignDialog() {
        this.dialogDigitalSign = false
        this.documentSignId = 0
        this.document_process_id = 0
        this.vista_action = ''
        this.vista_record_id = ''
        this.rowid_tercero = ''
        this.init()
      }
    },
  }
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
}
.table {
  margin-bottom: 1rem;
  background-color: #FFFFFF;
  max-width: 100%;
  width: 100%;
}
.table td, .table th {
  padding: .75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: middle;
  border-bottom: 2px solid #dee2e6;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0,0,0,.03);
}
.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #dee2e6;
}
.table-hover tbody tr:hover {
  background-color: rgba(5, 112, 199, 0.055);
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/documents/student_sign.vue